module.exports = __webpack_public_path__ + "house-ico.png?8249eeff0ad8460350edfaf23b03d609";